import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import {
  isPersonalUserAlertMessage,
  type PersonalUserAlertMessage,
} from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalUserAlertHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalUserAlertMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalUserAlertMessage(payload);
  }

  async handle(payload: PersonalUserAlertMessage, context: MessageHandlerContext): Promise<void> {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }
    const message =
      payload.data.message.message ?? '회원님께서는 경고처리 되었습니다. 경고가 누적될 시 불이익이 있을 수 있습니다.';

    if (context.hsms) {
      await context.hsms.openModal(
        'Confirm',
        { title: message, isShowCancelButton: false, confirmText: '確認' },
        { size: 'mid' },
      );
    } else if (context.pushModal) {
      context.pushModal({
        type: 'CONFIRM_MODAL',
        options: { description: message },
      });
    }
  }
}
